import { HIDE_PRODUCT_QUANTITY } from 'data/common';

interface BaseProduct {
  isOptional: boolean;
  properties?: {
    quantityRange?: number;
    isRequired?: boolean;
  };
}

/**
 * Filters optional products that meet specific conditions.
 *
 * This utility function returns products that are marked as optional
 * and have properties defined. Among these, it includes products
 * where the quantity is not hidden or the product is required.
 *
 * @param {Array} products - Array of product objects to filter.
 * @param {String} HIDE_PRODUCT_QUANTITY - The value used to indicate hidden product quantities.
 * @returns {Array} - Array of filtered optional products.
 */
// Make the function generic to accept any product type that extends BaseProduct
export function getFilteredOptionalProducts<T extends BaseProduct>(products: T[] = []) {
  return products.filter((product) => {
    return (
      product.isOptional &&
      product.properties &&
      (product.properties?.quantityRange !== HIDE_PRODUCT_QUANTITY ||
        product.properties?.isRequired)
    );
  });
}
